module.exports = __webpack_public_path__ + "img/feature_img.d3ccc9d9.png";